export const TXTWCL_Must_not_start_or_end_with_a_s_ELL = {
  "id": "TXTWCL_Must_not_start_or_end_with_a_s_ELL",
  "defaultMessage": "Must not start or end with a space"
} as const;